// extracted by mini-css-extract-plugin
export default {"root":"Header_root__ulnn3","content":"Header_content__6GqTo","side":"Header_side__avZR3","link":"Header_link__PkCjP","desktopOnly":"Header_desktopOnly__-GRDC"};